import { ShieldAlert, ShieldCheck, ShieldX } from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function VerdictPanel({ evaluation, title }) {
  const { labels, permisMeta } = useApp();
  if (!evaluation) return null;
  const { items = [], bloque, verdict, permisRequis = [] } = evaluation;
  const hasWarn = items.some((i) => i.niv === "warn");
  const cls = bloque ? "stop" : hasWarn ? "warn" : "ok";
  const Icon = bloque ? ShieldX : hasWarn ? ShieldAlert : ShieldCheck;
  const txt = title || (labels?.verdict?.[verdict] || (bloque ? "Incompatible" : hasWarn ? "Compatible sous conditions" : "Compatible"));

  return (
    <div className={`verdict ${cls}`} aria-live="polite" data-testid="verdict-panel">
      <div className="verdict-head"><Icon size={22} strokeWidth={2.2} />{txt}</div>
      {cls === "stop" && <div className="hatch" />}
      <div className="verdict-body">
        {permisRequis.length > 0 && (
          <div style={{ fontFamily: "'Space Mono'", fontSize: ".62rem", textTransform: "uppercase", color: "var(--text-muted)", marginBottom: 8 }}>
            Permis requis : {permisRequis.map((p) => permisMeta?.[p]?.nom || p).join(" · ")}
          </div>
        )}
        {items.length ? items.map((i, k) => (
          <div key={k} className={`vitem ${i.niv}`} data-testid={`verdict-item-${i.code}`}>
            <span className="code">{i.code}</span>
            <span className={`badge b-${i.niv === "stop" ? "bloque" : i.niv === "warn" ? "soumis" : "autorise"}`}>
              {i.niv === "stop" ? "Bloquant" : i.niv === "warn" ? "Alerte" : "Exigence levée"}
            </span>
            <div className="msg">{i.msg}</div>
            {i.fix && <div className="fix">Déblocage : {i.fix}</div>}
          </div>
        )) : <div className="empty">Aucune exigence ni conflit détecté par le moteur.</div>}
      </div>
    </div>
  );
}
